// Icons
import Medium from "@/Auth/assets/icons/medium.svg";
import Strong from "@/Auth/assets/icons/strong.svg";
import Weak from "@/Auth/assets/icons/weak.svg";

const MEDIUM_OPTION_1 = /((?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{6,}))/;
const MEDIUM_OPTION_2 = /((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))/;
const MEDIUM_REGEX = new RegExp(`(${MEDIUM_OPTION_1.source}|${MEDIUM_OPTION_2.source})`);
const STRONG_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{8,})/;

export type PasswordStrength = "Weak" | "Medium" | "Strong";

export function checkPasswordStrength(password: string): PasswordStrength {
	if (STRONG_REGEX.test(password)) {
		return "Strong";
	}
	if (MEDIUM_REGEX.test(password)) {
		return "Medium";
	}
	return "Weak";
}

export function iconFromStrength(strength: PasswordStrength) {
	switch (strength) {
		case "Medium":
			return <img src={Medium} alt="Medium indicator" />;
		case "Strong":
			return <img src={Strong} alt="Strong indicator" />;
		case "Weak":
			return <img src={Weak} alt="Weak indicator" />;
		default:
			return <></>;
	}
}
